<template>
    <div>
        <div class="gallery__row gallery__row--tabs">
            <div class="gallery__intro" v-html="collection.description"></div>
        </div>
        <div class="gallery__row">
            <select name="option" id="option-select"  class="gallery__select" @change="setSelectedGallery">
                <option :key="gallery.id" v-for="gallery in collection.galleries" :value="gallery.id" :selected="gallery.id == selectedGalleryId">{{ gallery.title }}</option>
            </select>
        </div>
        <div class="gallery__row gallery__row--gallery">
            <gallery-slider :key="gallery.id" v-for="gallery in collection.galleries" :id="gallery.id" :images="gallery.galleryImages" v-show="gallery.id == selectedGalleryId" />
        </div>
    </div>
</template>
<script>
import GallerySlider from './GallerySlider.vue'
import { EventBus } from './EventBus'

export default {
    props: {
		collection: Object
    },
    components: {
           gallerySlider : GallerySlider
    },
	data() {
		return {
            selectedGalleryId: {
                type: Number,
                default: null
            }
        };	
	},
    created: function () {
        this.selectedGalleryId = this.collection.galleries[0].id
    },
    methods: {
        setSelectedGallery(event) {
            this.selectedGalleryId = event.target.value
            EventBus.$emit('gallery-changed')
        }
    }
}
</script>